import { getAddress } from '1stdibs-contracts/addresses.js';
import { AUCTION_CONTRACT_NAME } from '1stdibs-contracts/contractNames.js';
import { getChainIdFromEnv, chains } from 'dibs-crypto-utils/exports/supportedChains.ts';

export function getAuctionContractAddress(): string | null {
    const chainId = getChainIdFromEnv();
    const chainName = chains.get(chainId);

    return chainName ? getAddress(AUCTION_CONTRACT_NAME, chainName.toLowerCase()) : null;
}
